import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="flex flex-col">
        <a href="https://form.jotform.com/211304498108856" target="_blank" rel="noreferrer">- Book Now -</a>
        <Link to={"/faq"}>
          - Frequently Asked Questions -
        </Link>
      </div>
      <div className="text-center mt-[5rem] mb-[2rem]">
        All Rights Reserved &copy; 2024 The Tattoo Studio
      </div>
    </>
  );
}

export default Footer;
